





import React, { useEffect, useReducer, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Img,
  SimpleGrid,
  Text,
  useColorModeValue,
  IconButton,
  InputGroup,
  InputLeftElement,
  Input,
  Badge,
} from '@chakra-ui/react';
import NFTBanner from 'assets/img/auth/topbg.jpg';
import Card from 'components/card/Card';
import Rocket from 'assets/img/games/rocket1-removebg-preview.png';
import { MdArrowCircleRight } from 'react-icons/md';
import { getAssignedGame } from 'utils/gameApplication/gamePlayService';
import { SearchIcon } from '@chakra-ui/icons';
import { VSeparator } from 'components/separator/Separator';
import { useNavigate } from 'react-router-dom';
import { updateGameRecentlyPlayed,trackGameStart } from 'utils/game/gameService';
import MobileOrientationPrompt from './playcards/MobileOrientationPrompt';
import { HashLoader } from 'react-spinners';
import { updateLearner } from 'utils/leaner/leaner';
type State = {
  level: string;
  payload?: any;
  gameTitle?: any;
};

type Action = {
  type?: string;
  payload?: any;
  gameTitle?: any;
  [x: string]: any;
};

const reducer = (state: State, action: Action) => {
  const { type, payload, gameTitle } = action;

  switch (type) {
    case 'level_0': {
      return { ...state, level: '0', payload };
    }
    case 'level_1': {
      return { ...state, level: '1', payload };
    }
    case 'level_2': {
      return { ...state, level: '2', payload };
    }
    case 'level_3': {
      return { ...state, level: '3', payload };
    }

    default:
      return state;
  }
};

const GamePlay: React.FC = () => {

  const navigate = useNavigate();
const [showEula, setShowEula] = useState(false);
  const [userId, setUserId] = useState(null);

const userData = JSON.parse(localStorage.getItem('user') || 'null');

const data = userData?.data;
const token = userData?.token;
const id = data?.id;


  const [assignedData, setFormData] = useState([]);
  const [fil, setFil] = useState<string>('');
  const [datas, setDatas] = useState<any>();
  // vignesh 08-01-24
  const [activeTab, setActiveTab] = useState("all");
  const [formData, setData] = useState({
    galGameId: null,
    galLearnerId: null,
    galGameState: 'level_0',
    galBlockId: null,
    galQuestionState: null,
    galTimeSpent: null,
    galAverageScore: null,
    galStartDateTime: null,
    galEndDateTime: null,
  });

  const searchIconColor = useColorModeValue('gray.700', 'white');

  const initialState: State = {
    level: '0',
  };



  useEffect(() => {
  if (data && data.lenTerms === false) {
    setShowEula(true);
  }
}, [data]);

  useEffect(() => {
  if (!userData || !data || !id) {
    localStorage.removeItem('user');
    navigate('/login');
  }
}, []);
  useEffect(() => {
    const userData = JSON.parse(
      localStorage.getItem('user') || '{}'
    );

  

    const learnerId = userData?.data?.id;

    if (learnerId) {
      setUserId(learnerId);

      setData((prevData) => ({
        ...prevData,
        galLearnerId: learnerId,
      }));
    }
  }, []);

  // Fetch assigned games after userId updates
  useEffect(() => {
    if (userId) {
      fetchAssignedGame(userId);
    }
  }, [userId]);


  const [state, dispatch] = useReducer<React.Reducer<State, Action>>(
    reducer,
    initialState,
  );
  const [loadingdata, setLoadingdata] = useState(true);
  const fetchAssignedGame = async (userId: any) => {
    setLoadingdata(true);
    try {
      const result = await getAssignedGame(userId);
      
      if (
  result?.status === 401 ||
  result?.message?.toLowerCase?.().includes("invalid")||
  result?.message?.toLowerCase?.().includes("unauthorized")||
  result?.status === "Failure"
) {
  localStorage.removeItem("user");
  navigate("/login");
  return;
}

      if (result?.data) {
        setFormData(result?.data); // Set the data if it exists
      } else {
        setFormData([]); // If no data, set as an empty array
      }
    } catch (error) {
      console.error('Error fetching assigned games:', error);
      setFormData([]); // Ensure it's empty in case of an error
    } finally {
      setLoadingdata(false);
    }
  };

  

  const handlePlay = async (gid: any) => {

     if (!gid) return;

  await trackGameStart(JSON.stringify({ 
    galGameId: gid, 
    galLearnerId: id  // ✅ id comes from localStorage user
  }));

    // if (gid) {
      const currentDate = new Date();

      const gameLog = await updateGameRecentlyPlayed(gid);
      if (gameLog?.status === 'Success') {
        navigate(`/play/${gid}`);
      }
    // }
  };

  useEffect(() => {
    localStorage.setItem('datas', datas);
  }, [datas]);

  useEffect(() => {
    const getData = localStorage.getItem('datas');
    dispatch({ type: getData });
  }, []);


  const filteredByTab = (assignedData || []).filter((game) => {
    if (activeTab === "completed") {
      return game?.gamerelatedstatus === "completed";
    }
    if (activeTab === "notYet") {
      return game?.status === "not yet started";
    }
    if (activeTab === "started") {
      return game?.status === "started";
    }
    return true; // default -> ALL
  });


  // const filteredData = (assignedData || []).filter((game) =>
  //   game.gameTitle?.toLowerCase().includes(fil.toLowerCase()),
  // );

  const filteredData = filteredByTab.filter((game) =>
    game?.gameTitle?.toLowerCase().includes(fil.toLowerCase())
  );

  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Box className="LearnerGames" position={'relative'}>
        <Box
          mb={{ base: '30px', xl: '30px' }}
          mt={{ base: '0px', md: '130px', xl: '100px' }}
          className="box"
        >
          <Card
            backgroundImage={NFTBanner}
            backgroundRepeat={'no-repeat'}
            backgroundSize={'cover'}
            height={'300px'}
            width={'100%'}
            h={'auto'}
            mt={{ base: '0px', md: '87px' }}
          >
            <Box
              display={{ base: 'block', xl: 'flex' }}
              justifyContent="space-between"
              alignItems={'end'}
              padding={{ base: '0', xl: '20px' }}
            >
              <Box display={'flex'} flexDirection={'column'}>
                <Heading
                  color={'#fff'}
                  pb={'20px'}
                  display={'flex'}
                  alignItems={'center'}
                >
                  Learning Adventures Hub{' '}
                  <Img
                    src={Rocket}
                    height={'50px'}
                    width={'50px'}
                    ml={'20px'}
                    transform={'rotate(40deg)'}
                  />
                </Heading>
                <Text fontSize={'15px'} color={'#fff'} letterSpacing={'1px'}>
                  Play. Learn. Grow. Succeed.
                </Text>
              </Box>
            </Box>
          </Card>
          <Card mt="25px">
            <Flex
              gridArea="1 / 1 / 2 / 2"
              display={{ base: 'block', lg: 'flex' }}
            >
              <VSeparator mx="30px" h="100%" />
              <InputGroup w={{ base: '100%', md: '300px' }} ml="auto">
                <InputLeftElement
                  children={
                    <IconButton
                      aria-label="search"
                      bg="inherit"
                      borderRadius="inherit"
                      _active={{
                        bg: 'inherit',
                        transform: 'none',
                        borderColor: 'transparent',
                      }}
                      _hover={{
                        background: 'none',
                      }}
                      _focus={{
                        background: 'none',
                        boxShadow: 'none',
                      }}
                      icon={
                        <SearchIcon color={searchIconColor} w="15px" h="15px" />
                      }
                    />
                  }
                />
                <Input
                  type="text"
                  placeholder="Search..."
                  value={fil || ''}
                  onChange={(e) => setFil(e.target.value)}
                  bg={'#f9f9f9'}
                  borderRadius={'14px'}
                  w={{ base: '200px', xl: '300px' }}
                />
              </InputGroup>
            </Flex>
          </Card>
        </Box>

        <Card
          mt="10px"
          content={assignedData.length === 0 ? 'Ooops...! No Game Found' : ''}
        // bg={assignedData.length === 0 ? 'grey' : ''}
        >
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
            {filteredData.length !== 0 &&
              filteredData?.map((game, i) => (
                <Card
                  key={i}
                  borderRadius={'15px'}
                  justifyContent={'center'}
                  boxShadow={'1px 4px 29px #44445429'}
                  transition="transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out"
                  position={'relative'}
                  width={'100%'}
                  padding={'10px'}
                  className="list-card"
                >
                  <Box
                    position={'relative'}
                    overflow={'hidden'}
                    borderRadius={'10px'}
                  >
                    <Img
                      className="list-img"
                      // src={img && img[i]?.gasAssetImage}
                      // src={'http://192.168.1.46:5555/uploads/background/9ls0_4iri_201221.jpg'}
                      // src={`http://192.168.1.46:5555/${game.gasAssetImage}`}
                      src={`${game?.image?.gasAssetImage}`}
                      height={'220px'}
                      width={'100%'}
                      borderRadius={'15px'}
                      position={'relative'}
                    />
                    {/* {game?.status === 'not yet started' && (
                      <Badge
                        position="absolute"
                        top="0px"
                        left="0px"
                        variant="solid"
                        borderTopLeftRadius={'5px'}
                        borderBottomLeftRadius={'0px'}
                        borderTopRightRadius={'0px'}
                      >
                        Newly Assigned
                      </Badge>
                    )} */}

                    {/* {game?.status === "not yet started" && (
                                <Badge
                                  position="absolute"
                                  top="0px"
                                  left="0px"
                                  variant="solid"
                                  borderRadius={"0px 0px 5px 0px"}
                                >
                                  Newly Assigned
                                </Badge>
                              )}
                    
                              {/* COMPLETED BADGE */}
                    {/* {game?.gamerelatedstatus === "completed" && (
                                <Badge
                                 position="absolute"
                                  top="0px"
                                  left="0px"
                                  variant="solid"
                                  borderRadius={"0px 0px 5px 0px"}
                                >
                                  Completed
                                </Badge>
                              )} */}
                    {game?.gamerelatedstatus === "completed" ? (
                      <Badge
                        position="absolute"
                        top="0px"
                        left="0px"
                        variant="solid"
                        borderRadius={"0px 0px 5px 0px"}
                      >
                        Completed
                      </Badge>
                    ) : game?.status === "not yet started" ? (
                      <Badge
                        position="absolute"
                        top="0px"
                        left="0px"
                        variant="solid"
                        borderRadius={"0px 0px 5px 0px"}
                      >
                        Newly Assigned
                      </Badge>
                    ) : null}

                  </Box>

                  <Flex justifyContent={'space-between'} margin={'10px 0'}>
                    <Box>
                      <Text
                        color={'#2b2b2ede'}
                        fontSize={'16px'}
                        fontWeight={'800'}
                      >
                        {game?.gameTitle}
                      </Text>

                      {/* {game?.skillNames.map((skill: any, i: any) => (
                        <Box
                          as="button"
                          key={i}
                          borderRadius="md"
                          bg="lightblue"
                          color="blue"
                          px={4}
                          // h={8}
                          margin={'2px 0 0 2px'}
                        >
                          {skill}
                        </Box>
                      ))} */}
                      {(game?.skillNames || []).map((skill: any, i: number) => (
                        <Box
                          as="button"
                          key={i}
                          borderRadius="md"
                          bg="lightblue"
                          color="blue"
                          px={4}
                          // h={8}
                          margin={'2px 0 0 2px'}
                          fontSize="lg"
                        >
                          {skill}
                        </Box>
                      ))}

                      <Text
                        color={'#745c5cc9'}
                        mt={'5px'}
                        fontSize={'14px'}
                        fontWeight={'700'}
                        height={'30px'}
                        textOverflow={'ellipsis'}
                        overflow={'hidden'}
                        whiteSpace={'nowrap'}
                      >
                        {game?.ctName}
                      </Text>
                    </Box>
                    <Box display={'flex'} alignItems={'center'}>
                      <Button
                        bg={'linear-gradient(to left, #7551ff, #3311db)'}
                        _hover={{
                          bg: 'linear-gradient(to left, #7551ff, #3311db)',
                        }}
                        borderRadius={'150px'}
                        height={'40px'}
                        width={'40px'}
                        boxShadow={'2px 4px 13px #4845456b'}
                        // onClick={handlePlay}
                        // onClick={() => handlePlay(game?.gameId)}
                          onClick={() => handlePlay(game?.gameId)}
                      >
                        <Icon
                          as={MdArrowCircleRight}
                          color={'#fff'}
                          fontSize={'22px'}
                        />
                      </Button>
                    </Box>
                  </Flex>
                </Card>
              ))}
          </SimpleGrid>
        </Card>
      </Box>
      {showEula && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  zIndex: 9999,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                }}
              >
                <div
                  style={{
                    background: 'white',
                    borderRadius: '12px',
                    width: '700px',
                    maxWidth: '90%',
                    maxHeight: '85vh',
                    display: 'flex',
                    flexDirection: 'column',
                    scrollBehavior: 'smooth',
                    boxShadow:
                      '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)',
                  }}
                >
                  <div
                    style={{
                      padding: '24px 32px 16px',
                      borderBottom: '2px solid #e2e8f0',
                      flexShrink: 0, // ← prevents it from shrinking
                    }}
                  >
                    <h1
                      style={{
                        fontSize: '24px',
                        fontWeight: '700',
                        margin: 0,
                        color: '#1a202c',
                        textAlign: 'center',
                      }}
                    >
                      {/* END USER LICENSE AGREEMENT (EULA) */}
                      Platform Access and Privacy Acknowledgement
                    </h1>
                  </div>
                  {/* Scrollable content */}
                  <div
                    style={{
                      overflowY: 'auto',
                      padding: '28px 32px',
                      flex: 1,
                      lineHeight: 1.6,
                      color: '#1a202c',
                    }}
                  >
                    <div
                      style={{
                        // background: '#fef3c7',
                        // borderLeft: '4px solid #f59e0b',
                        // padding: '16px 20px',
                        marginBottom: '24px',
                        // borderRadius: '8px',
                        fontSize: '14px',
                        lineHeight: 1.6,
                        // color: '#92400e',
                      }}
                    >
                      <strong>
                        By accessing the Atlantis training platform, you acknowledge
                        and agree that:
                      </strong>
                    </div>
                    {/* <p style={{ marginBottom: '20px', fontSize: '15px' }}>
                      This Agreement constitutes a legal agreement between you and
                      Leadupp Private Limited ("LeadUpp"), the owner and operator of
                      Atlantis ("Training Platform"). Its terms and conditions govern
                      your use of the Training Platform.
                    </p> */}
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      1. You will use the platform only for your assigned training and
                      learning purposes.
                    </p>
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      2. You will not share your login credentials or allow any other
                      person to access the platform using your account. You are
                      responsible for keeping your password and account information
                      confidential.
                    </p>{' '}
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      3. You will not reproduce, distribute, publicly display, modify
                      or create derivative works from the platform, training modules
                      or related materials, except where expressly permitted by
                      LeadUpp or your organisation.
                    </p>{' '}
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      4. You will not attempt to gain unauthorised access to the
                      platform, its systems, source code or underlying data, including
                      by reverse compiling, reverse assembling, reverse engineering or
                      bypassing access controls.
                    </p>{' '}
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      5. You will not misuse the platform, interfere with its
                      security, bypass or manipulate any access restrictions or
                      security-related features, knowingly introduce any virus,
                      malware, spyware, Trojan horse or other harmful code, or scrape,
                      harvest, extract or attempt to intercept any data from the
                      platform, its underlying systems or communications.
                    </p>{' '}
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      6. LeadUpp processes your personal data for purposes related to
                      providing, operating and supporting the platform, including user
                      authentication, access management, security, technical support,
                      performance monitoring, usage analytics, reporting,
                      troubleshooting, maintenance and product improvement. LeadUpp
                      will process your personal data in accordance with LeadUpp’s{' '}
                      <u>
                        <a
                          href="https://www.leadupp.co/privacypolicyleadupp.html"
                          target="blank"
                          style={{ color: 'blue' }}
                        >
                          Privacy Policy
                        </a>
                      </u>
                      .
                    </p>{' '}
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      7. Your learning progress, completion status and related
                      activity data will be available to your organisation for
                      training administration, reporting and program evaluation
                      purposes.
                    </p>{' '}
                    <p style={{ marginBottom: '10px', fontSize: '15px' }}>
                      8. Any information or materials made available to you through
                      the platform, including the training modules, platform content
                      and related materials, must be treated as confidential and must
                      not be disclosed to any third party except as authorised by
                      LeadUpp or your organisation.
                    </p>
                    <strong
                      style={{
                        marginBottom: '24px',
                        // borderRadius: '8px',
                        fontSize: '14px',
                        lineHeight: 1.6,
                      }}
                    >
                      By clicking Accept, you confirm that you have read, understood
                      and agree to this Platform Access and Privacy Acknowledgement.
                    </strong>
                  </div>
      
                  {/* Fixed footer with buttons */}
                  <div
                    style={{
                      padding: '16px 24px',
                      borderTop: '1px solid #e2e8f0',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      gap: '12px',
                      background: '#f8fafc',
                      borderRadius: '0 0 12px 12px',
                    }}
                  >
                  <button
  onClick={async () => {
    try {
      await updateLearner(id, JSON.stringify({ lenTerms: false }));
    } catch (err) {
      console.log(err);
    }

    localStorage.removeItem("user");
    navigate("/login");
  }}
  // style={{
  //   padding: "10px 24px",
  //   borderRadius: "8px",
  //   background: "#E53E3E",
  //   color: "white",
  //   border: "none",
  //   cursor: "pointer",
  //   fontSize: "14px",
  //   fontWeight: "500",
  // }}
>
  Deny
</button>
                   <button
  onClick={async () => {
    try {
      const payload = {
        lenTerms: true,
      };

      const res = await updateLearner(id, JSON.stringify(payload));

      if (res?.status === "Success") {
        // Update localStorage
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        user.data.lenTerms = true;
        localStorage.setItem("user", JSON.stringify(user));

        // Close popup
        setShowEula(false);
      }
    } catch (err) {
      console.log(err);
    }
  }}
  style={{
    padding: "10px 24px",
    borderRadius: "8px",
    background: "#422AFB",
    color: "white",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
  }}
>
  Accept
</button>
                     
                  </div>
                </div>
              </div>
            )}

    </>
  );
};

export default GamePlay;
